// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay */
.GInlBaNDR8j4DZ7n2Zum {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.sliezh5PF8eT88bfgX78 {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}
/* Container */
.lWqeOAmmZ90XQXXFvrUw {
  position: absolute;
  background-color: black;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* Desktop/default positioning */
  top: 50%;
  left: 50%;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border: 1px solid var(--dark-grey);
  /* Allow TSX to pass sizes via CSS vars; fallback to 100% */
  max-width: var(--modal-max-width, 100%);
  max-height: var(--modal-max-height, 100%);
}
/* Header */
.ehwo_b6FPMsR78LvDi9T {
  padding: 1.05vh;
  color: var(--settings-modal-text-color);
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  font-size: 3vh;
  font-weight: bold;
  position: relative;
}
/* Approximate responsive rules replacing theme.media */
@media (orientation: landscape) and (min-width: 1024px) {
  .ehwo_b6FPMsR78LvDi9T {
    font-size: 3vw;
  }
}
@media (min-width: 992px) {
  .ehwo_b6FPMsR78LvDi9T {
    font-size: 28px;
  }
}
/* Title */
.ngMWJQZrNunozx8u_uht {
  color: var(--settings-modal-text-color);
  font-size: 19.8px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  text-transform: uppercase;
  margin: 0;
}
@media (orientation: portrait) {
  .ngMWJQZrNunozx8u_uht {
    line-height: 3.1vh;
  }
}
/* Close button */
.i4M4pNtBBV6SxkCQImfl {
  position: absolute;
  right: 7.2px;
  top: 7.2px;
  width: 21.6px;
  height: 21.6px;
  min-height: 21.6px;
  min-width: 21.6px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #CF001C;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.i4M4pNtBBV6SxkCQImfl svg {
  width: 100%;
  height: 100%;
  display: block;
}
/* Content */
.qUurLZFmM5pw29caVslb {
  flex-grow: 1;
  overflow: auto;
  padding: 0 8px;
}
/* Mobile overrides */
@media (max-width: 767px) {
  .GInlBaNDR8j4DZ7n2Zum {
    height: calc(100dvh - var(--status-bar-height));
    align-items: stretch;
    justify-content: stretch;
    padding: 0;
  }
  .lWqeOAmmZ90XQXXFvrUw {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: none;
    border-radius: 0;
    /* ignore max sizes on mobile */
    max-width: 100%;
    max-height: 100%;
  }
  .i4M4pNtBBV6SxkCQImfl {
    display: none;
  }
}
/* POC animated lobby (?fx=1): spring-like entrance (settings modal is the only consumer). Backdrop
   fades; the container scales/translates in through the individual \`scale\` / \`translate\` properties
   so the desktop translate(-50%, -50%) and the mobile transform: none are both left alone. */
html[data-fx='1'] .GInlBaNDR8j4DZ7n2Zum:not(.sliezh5PF8eT88bfgX78) {
  animation: FQBPNIJQyYLIKkKqIsuP 220ms ease-out both;
}
html[data-fx='1'] .GInlBaNDR8j4DZ7n2Zum:not(.sliezh5PF8eT88bfgX78) .lWqeOAmmZ90XQXXFvrUw {
  animation: wajM2rUkvfEe5nvIxJ1f 420ms cubic-bezier(0.22, 1.25, 0.36, 1) both;
}
html[data-motion-tier='lite'] .GInlBaNDR8j4DZ7n2Zum:not(.sliezh5PF8eT88bfgX78) .lWqeOAmmZ90XQXXFvrUw {
  animation-duration: 240ms;
  animation-timing-function: ease-out;
}
html[data-motion-tier='off'] .GInlBaNDR8j4DZ7n2Zum,
html[data-motion-tier='off'] .GInlBaNDR8j4DZ7n2Zum .lWqeOAmmZ90XQXXFvrUw {
  animation: none;
}
@keyframes FQBPNIJQyYLIKkKqIsuP {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes wajM2rUkvfEe5nvIxJ1f {
  from {
    opacity: 0;
    scale: 0.94;
    translate: 0 18px;
  }
  to {
    opacity: 1;
    scale: 1;
    translate: 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Modal/Modal.module.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA,cAAc;AACd;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;EAClC,2DAA2D;EAC3D,uCAAuC;EACvC,yCAAyC;AAC3C;AACA,WAAW;AACX;EACE,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA,uDAAuD;AACvD;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,UAAU;AACV;EACE,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA,YAAY;AACZ;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA,qBAAqB;AACrB;EACE;IACE,+CAA+C;IAC/C,oBAAoB;IACpB,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;;6FAE6F;AAC7F;EACE,mDAA2C;AAC7C;AACA;EACE,4EAAiE;AACnE;AACA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;AACA;;EAEE,eAAe;AACjB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,QAAQ;IACR,cAAc;EAChB;AACF","sourcesContent":["/* Overlay */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  visibility: visible;\n  opacity: 1;\n  pointer-events: auto;\n}\n.overlayHidden {\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n/* Container */\n.container {\n  position: absolute;\n  background-color: black;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  /* Desktop/default positioning */\n  top: 50%;\n  left: 50%;\n  border-radius: 16px;\n  width: 100%;\n  height: 100%;\n  transform: translate(-50%, -50%);\n  border: 1px solid var(--dark-grey);\n  /* Allow TSX to pass sizes via CSS vars; fallback to 100% */\n  max-width: var(--modal-max-width, 100%);\n  max-height: var(--modal-max-height, 100%);\n}\n/* Header */\n.header {\n  padding: 1.05vh;\n  color: var(--settings-modal-text-color);\n  text-transform: uppercase;\n  text-align: center;\n  width: 100%;\n  font-size: 3vh;\n  font-weight: bold;\n  position: relative;\n}\n/* Approximate responsive rules replacing theme.media */\n@media (orientation: landscape) and (min-width: 1024px) {\n  .header {\n    font-size: 3vw;\n  }\n}\n@media (min-width: 992px) {\n  .header {\n    font-size: 28px;\n  }\n}\n/* Title */\n.title {\n  color: var(--settings-modal-text-color);\n  font-size: 19.8px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px;\n  text-transform: uppercase;\n  margin: 0;\n}\n@media (orientation: portrait) {\n  .title {\n    line-height: 3.1vh;\n  }\n}\n/* Close button */\n.close {\n  position: absolute;\n  right: 7.2px;\n  top: 7.2px;\n  width: 21.6px;\n  height: 21.6px;\n  min-height: 21.6px;\n  min-width: 21.6px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #CF001C;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.close svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n/* Content */\n.content {\n  flex-grow: 1;\n  overflow: auto;\n  padding: 0 8px;\n}\n/* Mobile overrides */\n@media (max-width: 767px) {\n  .overlay {\n    height: calc(100dvh - var(--status-bar-height));\n    align-items: stretch;\n    justify-content: stretch;\n    padding: 0;\n  }\n  .container {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transform: none;\n    border-radius: 0;\n    /* ignore max sizes on mobile */\n    max-width: 100%;\n    max-height: 100%;\n  }\n  .close {\n    display: none;\n  }\n}\n/* POC animated lobby (?fx=1): spring-like entrance (settings modal is the only consumer). Backdrop\n   fades; the container scales/translates in through the individual `scale` / `translate` properties\n   so the desktop translate(-50%, -50%) and the mobile transform: none are both left alone. */\n:global(html[data-fx='1']) .overlay:not(.overlayHidden) {\n  animation: fxBackdropIn 220ms ease-out both;\n}\n:global(html[data-fx='1']) .overlay:not(.overlayHidden) .container {\n  animation: fxModalIn 420ms cubic-bezier(0.22, 1.25, 0.36, 1) both;\n}\n:global(html[data-motion-tier='lite']) .overlay:not(.overlayHidden) .container {\n  animation-duration: 240ms;\n  animation-timing-function: ease-out;\n}\n:global(html[data-motion-tier='off']) .overlay,\n:global(html[data-motion-tier='off']) .overlay .container {\n  animation: none;\n}\n@keyframes fxBackdropIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fxModalIn {\n  from {\n    opacity: 0;\n    scale: 0.94;\n    translate: 0 18px;\n  }\n  to {\n    opacity: 1;\n    scale: 1;\n    translate: 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `GInlBaNDR8j4DZ7n2Zum`,
	"overlayHidden": `sliezh5PF8eT88bfgX78`,
	"container": `lWqeOAmmZ90XQXXFvrUw`,
	"header": `ehwo_b6FPMsR78LvDi9T`,
	"title": `ngMWJQZrNunozx8u_uht`,
	"close": `i4M4pNtBBV6SxkCQImfl`,
	"content": `qUurLZFmM5pw29caVslb`,
	"fxBackdropIn": `FQBPNIJQyYLIKkKqIsuP`,
	"fxModalIn": `wajM2rUkvfEe5nvIxJ1f`
};
export default ___CSS_LOADER_EXPORT___;
